'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { isSameParams } from '../components/url/isSameParams';
import { isSamePathname } from '../components/url/isSamePathname';
import { useHasChanged } from './useHasChanged';

export function useTriggerWhenTrue(trigger: () => void | Promise<void>, needsTrigger: boolean): void {
	// Do something if the value of the trigger is true
	useEffect(() => {
		if (!needsTrigger) {
			return;
		}
		if (!trigger) {
			return;
		}
		void trigger();
	}, [needsTrigger, trigger]);
}

export function usePathChanged(): boolean {
	const pathname = usePathname();
	const pathnameChanged = useHasChanged(pathname, isSamePathname);

	const searchParams = useSearchParams();
	const searchParamsChanged = useHasChanged(searchParams, isSameParams);

	// Do something when we navigate
	return Boolean(pathnameChanged || searchParamsChanged);
}

export function useTriggerOnPathChange(trigger: () => void): void {
	const pathChanged = usePathChanged();
	useTriggerWhenTrue(trigger, pathChanged);
}
